import classnames from "classnames";
import classes from "../../../styles/Resources.module.scss";
import Banner from "../../../components/common/Banner/Banner";
import BannerType from "../../../global/banner-type";
import resources from "../../../assets/images/resources.png";
import { dthentertainmentPSdata, faq } from "../../../global/constant";
import ContentSection from "../../../components/common/ContentSection/ContentSection";

const DTHEntertainment = () => {
  return (
    <div className={classnames(classes.main_content)}>
      <div className={classnames(classes.bannerSection)}>
        <Banner
          type={BannerType.SINGLE_IMAGE_BANNER}
          title="DTH & Entertainment"
          description="The media and entertainment industry consists of film, television, radio and print. These segments include movies, TV shows, radio shows, news, music, newspapers, magazines, and books."
          image={resources}
          maxWidth={214}
          className={classes.containerWidth}
        />
      </div>
      <ContentSection
        heading="Problem that can be solved using Paytm cloud solution"
        subHeading="A cloud solution allows users to access and manage their data,
        applications, and services remotely over the internet from a
        provider's servers."
        data={dthentertainmentPSdata}
        faqData={faq}
      />
    </div>
  );
};

export default DTHEntertainment;
